export const getNewInquiryDetails = (store: any) => store.newInquiryDetails.details;
